<template>
  <portlet class="campus_recruiting_content_area page_article_block">
    <template slot="header">
      <div class="content_title">
        {{ item.expoInfo.expo_title }}
      </div>
    </template>
    <career-expo-introduce :expo-info="item.expoInfo">
      <div class="article_info_item col-12">
        <span class="article_tag">附件</span>
      </div>
      <div class="article_info_item col-12">
        <div v-for="items in item.expoInfo.expo_attachments">
          <a
          :href="(items || { attachment_url: '#' }).attachment_url"
          target="_blank"
        >
          {{ (items || { attachment_file_name: '' }).attachment_file_name }}
        </a>
        </div>
      </div>
    </career-expo-introduce>
    <template slot="footer">
      <div class="row justify-content-center">
        <router-link
          :to="`/campus-recruiting/${$route.params.id}/career-expo`"
          class="detail_btn"
        >
          查看攤位配置圖
        </router-link>
      </div>
    </template>
  </portlet>
</template>
<script>
import Portlet from '~components/common/Portlet'
import CareerExpoIntroduce from '../common/CareerExpoIntroduce'
export default {
  name: 'CareerExpo',
  components: {
    Portlet,
    CareerExpoIntroduce
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
